import { TypedDocumentNode } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

// Local query data is seeded by initializeCache. Read it directly when SSR's
// first hook render has not yet resolved the @client operation.
export const useLocalQuery = <TData>(
  query: TypedDocumentNode<TData, Record<string, never>>,
  options: Omit<useQuery.Options<TData, Record<string, never>>, 'returnPartialData'> = {}
) => {
  const result = useQuery<TData, Record<string, never>>(query, options);
  const data = result.data ?? result.client.readQuery({ query, variables: options.variables });

  if (data == null) throw new Error('Local query data is missing from the initialized cache');

  return { ...result, data, dataState: 'complete' as const };
};
